import { useState } from "react";
import { IconButton, Tooltip, Button } from "@mui/material";
import { Delete } from "@mui/icons-material";
import DivExist from "./DivExist";

/**
 *
 * @param {object} param0
 * @param {function} param0.onBtnClick
 * @param {boolean} param0.hide
 * @param {"large"|"medium"|"small"} param0.size
 * @param {boolean} param0.disabled
 * @param {'inherit'|'primary'|'secondary'|'success'|'error'|'info'|'warning'} param0.color
 * @param {string} [param0.tooltip]
 * @param {boolean} [param0.withConfirm]
 * @returns
 */
export default function IconButtonDelete({
  onBtnClick,
  hide,
  size = "large",
  disabled,
  color,
  tooltip = "",
  withConfirm = false,
}) {
  const [showConfirm, setShowConfirm] = useState(false);
  return (
    <DivExist show={!hide}>
      <Tooltip title={tooltip}>
        <IconButton
          onClick={() => {
            if (withConfirm) {
              setShowConfirm(true)
            } else {
              onBtnClick()
            }
          }}
          size={size}
          disabled={disabled}
          color={color}
        >
          <Delete fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <DivExist show={showConfirm}>
        <Button size="small" variant="outlined" color="error" onClick={() => {
          setShowConfirm(false);
          onBtnClick();
        }}>
          Confirmed?
        </Button>
      </DivExist>
    </DivExist>
  );
}
